import { CheckCircle, Warning, Error, Dangerous } from "@mui/icons-material";
import { MsdRiskLevel } from "src/app/logic/assessment/msd/constants";

export interface MsdScoresDetailItem {
  level: MsdRiskLevel;
  detail: string;
  color: string;
  icon: any;
}

export type MsdScoreDetailType = {
  range: { min?: string | number; max?: string | number };
  detail: string;
  color: string;
  icon: any;
};

export const msdScoresDetail: MsdScoreDetailType[] = [
  {
    range: { min: MsdRiskLevel.LOW },
    detail:
      "Low Risk: No caution or hazard factors are present. Continue to monitor for any changes in work conditions or task requirements.",
    color: "#B2DFDB",
    icon: CheckCircle,
  },
  {
    range: { min: MsdRiskLevel.MODERATE },
    detail:
      "Moderate Risk: One or more caution zone factors are present. Monitor the job and take action if symptoms develop. Consider job rotation or modification to reduce exposure.",
    color: "#FFF176",
    icon: Warning,
  },
  {
    range: { min: MsdRiskLevel.HIGH },
    detail:
      "High Risk: Multiple caution zone factors (4+) or one or two hazard zone factors are present. Take action to reduce risk factors. Engineering controls or administrative controls should be implemented.",
    color: "#FFB74D",
    icon: Error,
  },
  {
    range: { min: MsdRiskLevel.VERY_HIGH },
    detail:
      "Very High Risk: Multiple hazard zone factors (3+) are present. Immediate intervention is required. Job should be redesigned or modified significantly to reduce exposure to risk factors.",
    color: "#B71C1C",
    icon: Dangerous,
  },
];

export const getMsdScoresDetailItem = (
  level: MsdRiskLevel,
): MsdScoresDetailItem => {
  const detailItems: Record<MsdRiskLevel, MsdScoresDetailItem> = {
    [MsdRiskLevel.LOW]: {
      level: MsdRiskLevel.LOW,
      detail:
        "Low Risk: No caution or hazard factors are present. Continue to monitor for any changes in work conditions or task requirements.",
      color: "#B2DFDB",
      icon: CheckCircle,
    },
    [MsdRiskLevel.MODERATE]: {
      level: MsdRiskLevel.MODERATE,
      detail:
        "Moderate Risk: One or more caution zone factors are present. Monitor the job and take action if symptoms develop. Consider job rotation or modification to reduce exposure.",
      color: "#FFF176",
      icon: Warning,
    },
    [MsdRiskLevel.HIGH]: {
      level: MsdRiskLevel.HIGH,
      detail:
        "High Risk: Multiple caution zone factors (4+) or one or two hazard zone factors are present. Take action to reduce risk factors. Engineering controls or administrative controls should be implemented.",
      color: "#FFB74D",
      icon: Error,
    },
    [MsdRiskLevel.VERY_HIGH]: {
      level: MsdRiskLevel.VERY_HIGH,
      detail:
        "Very High Risk: Multiple hazard zone factors (3+) are present. Immediate intervention is required. Job should be redesigned or modified significantly to reduce exposure to risk factors.",
      color: "#B71C1C",
      icon: Dangerous,
    },
  };

  return detailItems[level];
};
